<template>
  <component :is="tag" class="font-title font-extrabold" v-html="label" />
</template>

<script lang="ts" setup>
import type { CoursePackageWithDetailsView } from "~/business-areas/course-package/composables/course-packages.hook";

const properties = withDefaults(
  defineProps<{
    package: CoursePackageWithDetailsView;
    tag?: string;
  }>(),
  {
    tag: "span",
  },
);

const label = computed(() => {
  if (properties.package.type === "BASIC") return "Pollen Talent";
  if (properties.package.type === "PREMIUM")
    return 'Talent <strong class="text-accent">PLUS</strong>';
  if (properties.package.type === "PRIVATE") return "Pollen Team";
});
</script>
